import { isArray } from 'lodash';
import { SerializableObject } from '../../common-react/core';

import { CustomsInstructionsForHandling } from '../other/customs-instructions-for-handling.enum';

/** @see mobiz-posturinn-extension:Posturinn.Extension.Models.DTO.CustomsDocumentInformation */
export class CustomsDocumentInformation extends SerializableObject {
  public additionalInformation?: string;
  public instructionsForHandling?: CustomsInstructionsForHandling;
  public documents?: File[];
  public email?: string;

  public toFormData(): FormData {
    const formData = new FormData();
    for (const [key, value] of Object.entries(this)) {
      if (typeof value === 'string') {
        formData.append(key, value);
      } else if (key === 'documents' && isArray(value)) {
        value.forEach((documentFile: File): void => {
          formData.append('documents', documentFile, documentFile.name);
        });
      }
    }
    return formData;
  }
}
